import NextLink from 'next/link'
import { clientConfig } from '../../client'
import { checkNTRUrl } from '../../utils'
import { useExternalPaths } from '../../contexts'

type IProps = {
  href?: string
  className?: string
  children?: React.ReactNode
  target?: string
  ariaLabel?: string
  onClick?: () => void
  prefetch?: boolean
}

const isInternalUrl = (url?: string) => {
  if (url?.startsWith('/')) {
    return true
  }
  if (typeof window !== 'undefined') {
    return url?.startsWith(clientConfig.baseUrl)
  }
}

const Link = ({
  href,
  className,
  ariaLabel,
  target,
  children,
  onClick,
}: IProps) => {
  const hardReloadPaths = useExternalPaths()
  const forceHard = hardReloadPaths.some((p: string) => href?.includes(p))
  const getLinkRel =
    !href || isInternalUrl(href) || !checkNTRUrl(href) ? undefined : 'nofollow'

  if (href) {
    if (forceHard) {
      // 🚨 FORCE full reload
      return (
        <a
          href={href}
          rel={getLinkRel}
          className={[className, 'forced'].join(' ')}
          target={target}
          aria-label={ariaLabel}
          onClick={onClick}
        >
          {children}
        </a>
      )
    }
    return (
      <NextLink href={href}>
        <a
          rel={getLinkRel}
          className={className}
          target={target}
          aria-label={ariaLabel}
          onClick={onClick}
        >
          {children}
        </a>
      </NextLink>
    )
  }
  return (
    <a
      rel={getLinkRel}
      className={className}
      target={target}
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {children}
    </a>
  )
}

export default Link
